var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "621px",
    height: "621px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#363636",
    d: "M 620.5,300.5 C 620.5,307.167 620.5,313.833 620.5,320.5C 616.615,409.433 581.615,483.6 515.5,543C 459.858,592.054 394.858,617.887 320.5,620.5C 313.833,620.5 307.167,620.5 300.5,620.5C 205.022,615.845 127.189,576.512 67,502.5C 11.2244,430.026 -9.44228,348.359 5,257.5C 18.6748,183.214 54.1748,121.714 111.5,73C 185.053,12.939 269.053,-9.72766 363.5,5C 434.566,17.7745 494.066,50.9412 542,104.5C 591.702,160.261 617.869,225.594 620.5,300.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acacac",
    d: "M 479.5,191.5 C 495.005,190.173 510.672,190.173 526.5,191.5C 526.376,192.107 526.043,192.44 525.5,192.5C 510.342,191.504 495.009,191.17 479.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 294.5,291.5 C 295.232,300.815 295.566,310.148 295.5,319.5C 238.5,319.5 181.5,319.5 124.5,319.5C 123.836,321.978 123.503,324.645 123.5,327.5C 123.379,332.093 124.046,336.426 125.5,340.5C 131.369,372.536 150.369,391.369 182.5,397C 207.938,401.111 229.438,393.944 247,375.5C 250.919,369.547 253.752,363.214 255.5,356.5C 267.5,356.5 279.5,356.5 291.5,356.5C 291.5,357.833 291.5,359.167 291.5,360.5C 283.958,391.879 264.958,413.046 234.5,424C 210.27,431.615 185.937,432.448 161.5,426.5C 159.485,425.076 157.152,424.41 154.5,424.5C 121.447,412.608 100.281,389.608 91,355.5C 89.3012,348.834 87.8012,342.167 86.5,335.5C 86.473,329.949 85.8063,324.616 84.5,319.5C 81.0795,278.913 93.7462,244.413 122.5,216C 158.318,187.596 197.318,182.596 239.5,201C 272.47,222.078 290.803,252.245 294.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 479.5,191.5 C 495.009,191.17 510.342,191.504 525.5,192.5C 498.349,228.494 471.349,264.661 444.5,301C 474.381,343.267 504.381,385.433 534.5,427.5C 518.534,429.485 502.201,430.152 485.5,429.5C 463.917,396.578 441.917,363.912 419.5,331.5C 397.083,363.912 375.083,396.578 353.5,429.5C 337.797,430.151 322.464,429.484 307.5,427.5C 336.373,386.258 365.373,345.091 394.5,304C 366.988,266.651 339.654,229.151 312.5,191.5C 329.167,190.167 345.833,190.167 362.5,191.5C 381.513,218.871 400.513,246.204 419.5,273.5C 439.509,246.137 459.509,218.804 479.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#373737",
    d: "M 255.5,283.5 C 255.5,284.833 255.5,286.167 255.5,287.5C 212.167,287.5 168.833,287.5 125.5,287.5C 125.5,284.5 125.5,281.5 125.5,278.5C 130.605,252.559 145.605,235.059 170.5,226C 202.077,218.884 227.244,228.384 246,254.5C 251.278,263.501 254.445,273.168 255.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#444444",
    d: "M 125.5,278.5 C 125.5,281.5 125.5,284.5 125.5,287.5C 168.833,287.5 212.167,287.5 255.5,287.5C 212.003,288.499 168.337,288.832 124.5,288.5C 124.187,284.958 124.521,281.625 125.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebebe",
    d: "M 255.5,283.5 C 256.461,285.265 256.795,287.265 256.5,289.5C 212.33,289.832 168.33,289.499 124.5,288.5C 168.337,288.832 212.003,288.499 255.5,287.5C 255.5,286.167 255.5,284.833 255.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a0a0",
    d: "M 294.5,291.5 C 295.984,296.925 296.651,302.591 296.5,308.5C 296.499,312.349 296.165,316.016 295.5,319.5C 295.566,310.148 295.232,300.815 294.5,291.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787878",
    d: "M 84.5,319.5 C 85.8063,324.616 86.473,329.949 86.5,335.5C 85.0427,330.402 84.376,325.069 84.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdbdbd",
    d: "M 124.5,319.5 C 124.435,326.524 124.768,333.524 125.5,340.5C 124.046,336.426 123.379,332.093 123.5,327.5C 123.503,324.645 123.836,321.978 124.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 255.5,356.5 C 267.655,355.505 279.989,355.171 292.5,355.5C 292.784,357.415 292.451,359.081 291.5,360.5C 291.5,359.167 291.5,357.833 291.5,356.5C 279.5,356.5 267.5,356.5 255.5,356.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbbbbb",
    d: "M 154.5,424.5 C 157.152,424.41 159.485,425.076 161.5,426.5C 158.848,426.59 156.515,425.924 154.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d4d4",
    d: "M 307.5,427.5 C 322.464,429.484 337.797,430.151 353.5,429.5C 337.662,430.827 321.662,430.827 305.5,429.5C 305.855,428.478 306.522,427.811 307.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3d3d3",
    d: "M 534.5,427.5 C 535.478,427.811 536.145,428.478 536.5,429.5C 519.338,430.827 502.338,430.827 485.5,429.5C 502.201,430.152 518.534,429.485 534.5,427.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.f509d4a5ee0a67de6b94754f73e0bf18.svg";
export { ForwardRef as ReactComponent };